/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ExportPrompt} from '@ion/dls/src/export/ExportPrompt';
import {
  exportComplete,
  exportConfirmed
} from '@/store/actions/exporter';

/**
 * @ExportPrompt
 */
export const ExportStatusPrompt = () => {
  const {
    entity,
    isExporting,
    isComplete,
    isError,
    message
  } = useSelector(({exporter}) => exporter.current);
  const dispatch = useDispatch();
  return (
    <ExportPrompt entity={entity}
      isExporting={isExporting && !isComplete}
      message={message}
      isFailure={isError}
      onComplete={function() {
        dispatch(isComplete ? exportComplete() : exportConfirmed());
      }} />
  );
};

export default ExportStatusPrompt;
